module.exports = __webpack_public_path__ + "img/metroid.7531870b.png";